<template>
  <div :class="className" class="title-widget">
    <div class="position-relative">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
  },
  computed: {
    className() {
      const alignClass = {
        left: "text-left align-start",
        center: "text-center align-center",
        right: "text-right align-end",
      };

      const className = [
        "d-flex flex-column justify-center text-h5 text-md-h4 font-weight-bold title-widget",
        alignClass[this.align],
      ];

      return className;
    },
  },
};
</script>

<style lang="scss">
.title-widget--light {
  --text: var(--v-secondary-base);
  --decoration: var(--v-secondary-base);
  --hover-text: var(--v-primary-lighten1);
}
.title-widget--dark {
  --text: #ffffff;
  --decoration: var(--v-primary-base);
  --hover-text: #ccc;
}

.title-widget {
  text-decoration: none;

  > * {
    color: var(--text) !important;
  }
}

.title-widget > div {
  &:before {
    aspect-ratio: 61 / 62;
    background-image: url(../../assets/img/logo-icon.png);
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    left: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 61px;

    @media screen and (max-width: 959.9px) {
      width: 46px;
    }
  }
}

.title-widget--link a {
  transition: 0.3s;

  i {
    opacity: 0;
    color: inherit !important;
  }

  &:hover {
    color: var(--hover-text) !important;

    i {
      opacity: 1;
    }
  }
}
</style>
